export function initGmatTable() {
  if (document.body.offsetWidth < 468) {
    initGmatTableMobile();
  } else {
    initGmatTableDesktop();
  }
}

function initGmatTableDesktop() {
  const $table = document.querySelector('.table__gmat table');

  if (!$table) {
    return false;
  }

  const td = $table.querySelectorAll('td');
  const tr = $table.querySelectorAll('tr');
  const $style = document.createElement('style');

  document.head.appendChild($style);

  tr.forEach(el => {
    el.querySelectorAll('td').forEach((el, idx) => {
      el.classList.add(`td--${idx}`);
    });
  });

  td.forEach(el => {
    if (el.classList.contains('quant-y-axis')) {
      return;
    }

    el.addEventListener(
      'mouseenter',
      evt => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nthChild = (evt.target as HTMLElement).className.match(/td--[0-9]+/gi)!;
        $style.innerHTML = `tr th:nth-child(${
          parseInt(nthChild[0].replace('td--', ''), 10) + 1
        }), .${nthChild[0]} {
        background: #FEFFEF !important
      }`;
      },
      false,
    );

    el.addEventListener(
      'mouseleave',
      () => {
        $style.innerHTML = '';
      },
      false,
    );
  });

  return true;
}

function initGmatTableMobile() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const $tableWrapper = document.querySelector('.table__gmat')!;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const $tableData = document.querySelector('.wp-block-table.is-style-stripes')!;

  if (!$tableData || !$tableWrapper) {
    return false;
  }

  $tableWrapper.classList.add('table__gmat--scrollable');

  // Build markup for scrollable table

  // Adds X Axis
  const trYAxis = document.createElement('tr');

  let xAxisHtml = ``;

  $tableWrapper.querySelectorAll('.verbal-heading th').forEach((el, idx) => {
    if (idx) {
      xAxisHtml += `<th>${el.innerHTML}</th>`;
    }
  });

  trYAxis.innerHTML = `<td></td><td style="border: 1px solid #ccc; padding: 0;"></td>
  <td style="padding: 0; border-right: 1px solid #ccc;">
    <div id="XAxis" style="overflow: hidden;">
      <table id="XAxisTable" style="border:0;margin:0;">
       <tr>${xAxisHtml}</tr>
      </table>
    </div>
  </td>`;

  $tableWrapper
    .querySelector('tbody')
    ?.insertBefore(trYAxis, $tableWrapper.querySelector('tr:last-child'));

  // Adds Y Axis
  const tdYAxis = document.createElement('td');
  // Fetch Y Axis data
  tdYAxis.setAttribute('style', 'padding: 0; border-bottom: 1px solid #ccc;');
  let yAxisHtml = '';
  document.querySelectorAll(`.quant-y-axis`).forEach(el => {
    yAxisHtml += `<tr><td class="quant-y-axis">${el.innerHTML}</td></tr>`;
    el.remove();
  });
  tdYAxis.innerHTML = `<div id="YAxis" style="overflow: hidden;">
    <table id="YAxisTable" style="border: 0; margin: 0">${yAxisHtml}</table></div>`;

  document
    .querySelector('.table__gmat > tbody > tr:nth-child(3)')
    ?.insertBefore(tdYAxis, $tableWrapper.querySelector('tr:last-child td:last-child'));

  // Wrap data table in scrolling container
  const scrollingContainer = document.createElement('div');
  scrollingContainer.className = 'menlo-scrolling-container';
  scrollingContainer.style.overflow = 'scroll';
  $tableData.parentNode?.insertBefore(scrollingContainer, $tableData);
  scrollingContainer.appendChild($tableData);
  scrollingContainer.parentElement?.setAttribute(
    'style',
    'padding: 0; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;',
  );

  // Colspan
  $tableWrapper.querySelector('td:first-child')?.setAttribute('colspan', '2');

  // Tidy up
  $tableWrapper.querySelector('.verbal-heading')?.remove();

  // Sizing elements
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const XAxis = document.querySelector<HTMLElement>('#XAxis')!;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const YAxis = document.querySelector<HTMLElement>('#YAxis')!;

  scrollingContainer.style.width = '0px !important';
  const width = calcScrollingTableWidth(document.body.offsetWidth - 115, 45);
  scrollingContainer.style.width = `${width}px`;
  XAxis.style.width = `${width}px`;

  const height = `60vh`;
  scrollingContainer.style.height = height;
  YAxis.style.height = height;

  // Syncing the X and Y Axis
  const yAxisTable = document.querySelector<HTMLElement>('#YAxisTable');
  const xAxisTable = document.querySelector<HTMLElement>('#XAxisTable');

  function calcScrollingTableWidth(proposedWidth: number, cellWidth: number) {
    const numberOfWholeColumns = Math.floor(proposedWidth / cellWidth);
    return (
      (numberOfWholeColumns + (proposedWidth % cellWidth > cellWidth * 0.5 ? 0.5 : -0.5)) *
      cellWidth
    );
  }

  function step() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    yAxisTable!.style.transform = `translateY(${scrollingContainer.scrollTop * -1}px)`;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xAxisTable!.style.transform = `translateX(${scrollingContainer.scrollLeft * -1}px)`;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);

  return true;
}
